import Link from 'components/misc/Link'
import compose from 'lib/helpers/compose'
import { connect } from 'react-redux'
import Modal from 'components/misc/Modal'
import { toggleModal } from 'store/ui/actions'
import styles from './styles/CustomDashboardLimitErrorModal.css'
import Button from 'components/forms/Button'
import Header from 'components/typography/Header'
import P from 'components/typography/Paragraph'

const CustomDashboardLimitErrorModal = ({ dashboardLimitErrorModalShow, toggleModal }) => {
  const toggleDashboardLimitModal = () => {
    toggleModal('dashboardLimitError')
  }
  return (
    <Modal
      className={styles.modal}
      toggle={toggleDashboardLimitModal}
      show={dashboardLimitErrorModalShow}
    >
      <Header level={4}>Dashboard DOI Limit Exceeded</Header>
      <P>It looks like you tried to create a custom dashboard that exceeded the DOI limit for your account.</P>
      <P>You can try again with fewer DOIs, or get in touch at
        <Link blue href='mailto:sales@scite.ai'> sales@scite.ai</Link> about increasing the limits on your custom dashboards.
      </P>
      <Button type='button' className={styles.cancelBtn} onClick={toggleDashboardLimitModal} color='transparent'>Close</Button>
    </Modal>
  )
}

const mapStateToProps = ({ ui: { dashboardLimitErrorModalShow } }) => ({
  dashboardLimitErrorModalShow
})

const actionCreators = {
  toggleModal
}

export default compose(
  connect(mapStateToProps, actionCreators)
)(CustomDashboardLimitErrorModal)
